<template>
    <modal id="salary-sheet-import"
           size="large"
           v-model="showModal"
           :title="$t('import')"
           :preloader="preloader"
           :loading="loading"
           @submit="submitData">
        <form ref="form" :data-url='`${TENANT_BASE_URL}app/salary-sheet/import`' @submit.prevent="submitData">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label>{{ $t('file') }}</label>
                        <div class="custom-file" style="height: 44px;">
                            <input type="file" id="file" v-on:change="change" class="custom-file-input" accept=".csv">
                            <label for="file" class="custom-file-label" v-text="placeholder" style="padding: 10px 14px !important;"/>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>{{ $t('employee_id') }}</label>
                        <select class="form-control" v-model="formData.employee_id">
                            <option value="">---</option>
                            <option v-for="header in headers" :value="header.id" v-text="header.label"/>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        :label="$t('month')"
                        type="search-select"
                        v-model="formData.month"
                        list-value-field="name"
                        :placeholder="$placeholder('month', '')"
                        :error-message="$errorMessage(errors, 'month')"
                        :fetch-url="`${apiUrl.COMMON}/get-months`"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="number"
                        :label="$t('base_salary')"
                        :placeholder="$placeholder('base_salary')"
                        v-model="formData.base_salary"
                        :error-message="$errorMessage(errors, 'base_salary')">
                    </app-form-group>
                </div>
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="d-flex justify-content-between border-bottom mb-2">
                                    <h6>{{ this.$t('allowance') }}</h6>
                                </div>
                                <div v-if="beneficiaries.length">
                                    <div class="row align-items-center mt-2" v-for="(allowance, index) in allowances" :key="index">
                                        <div class="col-md-5">
                                            <label class="text-left d-block mb-lg-0">
                                                {{ allowance.name }}
                                            </label>
                                        </div>
                                        <div class="col-md-7">
                                            <select class="form-control" v-model="formData.allowanceValues[allowance.id]">
                                                <option value="">---</option>
                                                <option v-for="header in headers" :value="header.id" v-text="header.label"/>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <div class="d-flex justify-content-between border-bottom mb-2">
                                    <h6>{{ this.$t('deduction') }}</h6>
                                </div>
                                <div v-if="beneficiaries.length">
                                    <div class="row align-items-center mt-2" v-for="(deduction, index) in deductions" :key="index">
                                        <div class="col-md-5">
                                            <label class="text-left d-block mb-lg-0">
                                                {{ deduction.name }}
                                            </label>
                                        </div>
                                        <div class="col-md-7">
                                            <select class="form-control" v-model="formData.deductionValues[deduction.id]">
                                                <option value="">---</option>
                                                <option v-for="header in headers" :value="header.id" v-text="header.label"/>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <app-form-group
                        type="switch"
                        :label="$t('status')"
                        v-model="formData.status"
                    />
                </div>
                <div class="col-md-12">
                    <app-form-group
                        type="textarea"
                        :label="$t('note')"
                        :placeholder="$textAreaPlaceHolder('note')"
                        v-model="formData.note"
                        :text-area-rows="4"
                        :error-message="$errorMessage(errors, 'note')">
                    </app-form-group>
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";
import {formDataAssigner} from "../../../../common/Helper/Support/FormHelper";
import {axiosGet} from "../../../../common/Helper/AxiosHelper";

export default {
    name  : "SalarySheetImportModal",
    mixins: [FormHelperMixins, ModalMixin],
    props : {
        rowData: {},
    },
    data() {
        return {
            TENANT_BASE_URL,
            beneficiaries: [],
            headers      : [],
            fieldValue   : null,
            placeholder  : this.$placeholder('file', 'csv'),
            formData     : {
                allowanceValues: {},
                deductionValues: {},
            },
        }
    },
    created() {
        this.getBeneficiaries();
    },
    computed: {
        allowances() {
            return this.beneficiaries.filter(benefit => benefit.type === 'allowance');
        },
        deductions() {
            return this.beneficiaries.filter(benefit => benefit.type === 'deduction');
        },
    },
    methods : {
        getBeneficiaries() {
            this.preloader = true;
            axiosGet(this.apiUrl.SELECTABLE_BENEFICIARY_BADGE).then(({data}) => {
                this.beneficiaries = data
            }).finally(() => {
                this.preloader = false;
            })
        },
        change(event) {
            const placeholder = this.$placeholder('file', 'csv')
            this.fieldValue   = event.target.files[0];
            this.headers      = [];

            if (this.fieldValue) {
                const reader  = new FileReader();
                reader.onload = (e) => {
                    const data   = e.target.result;
                    const header = data.split(/[\r\n]+/)[0].split(",")

                    for (const index in header) {
                        this.headers.push({
                            id   : index,
                            label: header[index],
                        })
                    }
                }

                reader.readAsText(this.fieldValue);

                this.placeholder = this.fieldValue?.name || placeholder;
            } else {
                this.placeholder = placeholder;
                this.fieldValue  = null;
            }
        },
        submitData() {
            this.loading   = true
            const url      = this.$refs.form.dataset["url"];
            const formData = formDataAssigner(new FormData, this.formData);

            formData.set('import_file', this.fieldValue)

            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            $('#salary-sheet-import').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'salary-sheet-table');
        },
        afterSuccessFromGetEditData(response) {
            this.loading     = false;
            this.preloader   = false;
            this.fieldValue  = null;
            this.headers     = [];
            this.formData    = {};
            this.placeholder = this.$placeholder('file', 'csv');
        },
    }
}
</script>

